import React, { useRef } from 'react'
import { nl2br } from '../../helpers/nl2br'
import { useParallaxCalculation } from '../../hooks/useParallax'

import { motion } from 'framer-motion'

const M03Testimonial = ({ quote, author, photo, anchorLinkId }) => {
  const ref = useRef(null)
  const parallaxRef = useRef(null)
  const { yRef1, yRef2, recalculateParallax } = useParallaxCalculation({
    ref1: ref,
    ref2: parallaxRef,
  })

  return (
    <section className="py-10 my-10 md:my-20 md:py-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-b">
          <div className="col-1-type-b" ref={ref}>
            {photo && photo.length > 0 && (
              <motion.img
                src={photo[0]?.url}
                alt={author}
                onLoad={recalculateParallax}
                style={{ y: yRef1 }}
                className="w-full h-auto rounded shadow-tpmp lg:shadow-dp -z-1"
              />
            )}
          </div>
          <motion.div className="col-2-type-b" style={{ y: yRef2 }}>
            <div
              className="relative z-10 pt-5 pl-5 -top-6 u-p sm:pt-0 sm:pl-0 sm:top-0 bg-gray-1 sm:bg-transparent"
              ref={parallaxRef}
            >
              <div className="mb-4">
                <q
                  className="u-quote link-wrapper"
                  dangerouslySetInnerHTML={{ __html: quote }}
                />
              </div>
              <div
                className="column-indent link-wrapper"
                dangerouslySetInnerHTML={{ __html: nl2br(author) }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default M03Testimonial
